<template>
    <div>

        <div class="mk1 w1200">
            <div class="tit">
                <div class="bt">实体投注站帮扶中心</div>
                <div class="nav">
                    <span v-for="(item,index) in mk1.title"
                          :key="index"
                          :class="mk1.active == index?'active':''"
                          @click="navtit(index)">{{item}}</span>
                </div>
            </div>
            <!-- <img src="./img/img.png"
                 alt=""> -->
            <div class="content">
                <div class="cont">
                    <h1>招募最牛的缩水师<br />成就您的彩票梦想</h1>
                    <p>
                        <span>专业团队</span>
                        <span>服务保障</span>
                    </p>
                    <div class="btns">
                        <span @click="bidu.show = true;bidu.title='投注站必读'">投注站必读</span>
                        <span @click="bidu.show = true;bidu.title='彩票经理必读'">彩票经理必读</span>
                        <span @click="bidu.show = true;bidu.title='彩票代表必读'">彩票代表必读</span>
                    </div>
                    <div class="more"></div>
                </div>
            </div>
        </div>

        <div class="mk2 w1200">
            <img src="./img/chaoshi.png"
                 alt="">
            <img src="./img/zhongchou.png"
                 alt="">
        </div>

        <div style="background-color: #e8e6e7;">
            <div class="mk5 w1200">
                <div class="tit">
                    <h3>中国彩票开奖公告</h3>
                    <div>Lottery draw</div>
                </div>
                <div class="content">
                    <!-- 票种及开奖时间 -->
                    <div class="lottery">
                        <div v-for="(item,index) in mk5.lottery.arr"
                             :key="index"
                             @click="mk5.lottery.active = index">
                            <span :class="mk5.lottery.active == index?'active':''">{{item.name}}</span>
                            {{item.kj}}
                        </div>
                    </div>

                    <!-- 彩种信息 -->
                    <div class="info">
                        <img src=""
                             alt="">
                        <div>
                            <div class="one">
                                <div>
                                    <span>双色球</span>
                                    <span>第123123期开奖结果</span>
                                    <span>奖池滚存<b>￥123123132元</b></span>
                                </div>
                                <div>每周二、四、日开奖</div>
                            </div>
                            <div class="num">
                                <span v-for="(item,index) in 7"
                                      :key="index"
                                      :class="index>3?'red':'blue'">{{item}}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 开奖结果 -->
                    <div class="kjjg">
                        <div class="tit">往期开奖结果</div>
                        <el-table>
                            <el-table-column label="期号"></el-table-column>
                            <el-table-column label="开奖日期"></el-table-column>
                            <el-table-column label="开奖号码"></el-table-column>
                            <el-table-column label="总销数额(元)"></el-table-column>
                            <el-table-column label="奖池(元)"></el-table-column>
                            <el-table-column label="开奖视频"></el-table-column>
                        </el-table>
                    </div>

                    <!-- 实战超市 -->
                    <div class="szcs">
                        <div class="left">
                            <div>众筹招股</div>
                            <div>实体投注站帮扶中心</div>
                        </div>
                        <div class="right">
                            <div class="tit">实战超市</div>
                            <el-table>
                                <el-table-column label="实战团队"></el-table-column>
                                <el-table-column label="期数"></el-table-column>
                                <el-table-column label="实战方案"></el-table-column>
                                <el-table-column label="上期实战盈亏状态"></el-table-column>
                                <el-table-column label="排名"></el-table-column>
                                <el-table-column label="价格"></el-table-column>
                            </el-table>
                        </div>
                    </div>

                </div>
                <div class="bg"></div>
            </div>
        </div>

        <div class="mk3 w1200">
            <el-carousel :interval="3000"
                         arrow="always">
                <el-carousel-item v-for="item in 4"
                                  :key="item">
                    <h3>{{ item }}</h3>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div style="background-color: #787878;">
            <div class="mk4 w1200">
                <div class="ul">
                    <ul>
                        <li>申请</li>
                        <li>彩票代表</li>
                        <li>彩票经理</li>
                        <li>彩票投注站帮扶</li>
                    </ul>
                    <ul>
                        <li>必读</li>
                        <li @click="bidu.show = true;bidu.title='彩票代表必读'">彩票代表必读</li>
                        <li @click="bidu.show = true;bidu.title='彩票经理必读'">彩票经理必读</li>
                        <li @click="bidu.show = true;bidu.title='投注站必读'">投注站必读</li>
                    </ul>
                    <ul>
                        <li>实战超市</li>
                        <li>帮扶投注站</li>
                        <li>专业团队出品</li>
                    </ul>
                    <ul>
                        <li>众筹招股</li>
                        <li>技术团队入股5%</li>
                        <li>平台兜底10%</li>
                        <li>按股分红</li>
                    </ul>
                    <ul>
                        <li>合同保障</li>
                        <li>实战方案</li>
                        <li>实战票</li>
                        <li>站长签名</li>
                        <li>签订合同</li>
                    </ul>
                </div>
                <div class="ewm">
                    <div>
                        <div class="img">二维码</div>
                        <span>实战超市大厅</span>
                    </div>
                    <div>
                        <div class="img">二维码</div>
                        <span>众筹招股大厅</span>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="bidu.title"
                   :visible.sync="bidu.show"
                   width="60%">
            <img v-if="bidu.title == '彩票代表必读'"
                 src="./img/bidu/daibiao.png"
                 alt=""
                 style="width:100%;margin:auto">
            <img v-if="bidu.title == '彩票经理必读'"
                 src="./img/bidu/jingli.png"
                 alt=""
                 style="width:100%;margin:auto">
            <div v-if="bidu.title == '投注站必读'"
                 class="tzzbd">
                <p class="tit">
                    <span>投注站必读</span>
                </p>
                <p>一、彩票投注站首先书写一份申请书，工作人员核实后，正式报备成为待帮扶的投注站，平台给您按照申请的时间先后排号。</p>
                <p>二、当彩票投注站正式收到平台帮扶通知书或者工作人员的电话通知，就可以办理正式入驻，接收平台的帮扶服务。目前只提供双色球和大乐透的服务。</p>
                <p>三、彩票投注站根据自己是福彩店还是体彩店，在帮扶实战超市大厅预订双色球或大乐透帮扶实战方案。订金是帮扶实战方案的30%，当投注站站长众筹招股在约定的截止时没有成功，订金原路返回到投注站在平台的账户上。四、按照行业惯例，出帮扶方案的团队将认购5%的股权，平台将认购10%的股权，帮扶中心栏目组将认购2%的股权。</p>
                <p>四、彩票代表和彩票经理会帮助彩票投注站众筹招股近可能成功，平台收取2%的股权（实战方案本金+实战团队帮扶方案价格）的管理服务费。其中 1%作为彩票代表的劳务酬金，0.2%作为彩票经理的劳务酬金。</p>
                <p>五、彩票投注站众筹招股众筹招股成功，可以第一时间申请缩币提现，也可以先垫付出实战票。</p>
                <p>六、彩票投注站站长出了实战票，请尽快完成缩水网帮扶中心四件套：帮扶合同+帮扶方案+实战票+投注站负责人当期签名拍照上传（我承诺：我将忠实履行缩水网帮扶合同，某某某，年、月、日。)</p>
                <p>七、每期开完奖，彩票投注站请在14小时内完成每一位参与众筹招股股权的兑奖。</p>
            </div>
            <!-- <img src="./img/bidu/touzhuzhan.png"
                 alt=""
                 style="width:100%;margin:auto"> -->
        </el-dialog>

        <chaoshi ref="chaoshi" />
        <zhaogu ref="zhaogu" />
        <hetong ref="hetong" />

    </div>
</template>

<script>
import chaoshi from './dating/chaoshi.vue'
import zhaogu from './dating/zhaogu.vue'
import hetong from './dating/hetong.vue'
export default {
    components: {
        chaoshi, zhaogu, hetong
    },
    data () {
        return {
          chaoshi_tableData: [],
            mk1: {
                title: ['投注站申请帮扶', '实体超市大厅', '众筹招股大厅', '实战合同存档'],
                active: 0,
            },
            mk5: {
                lottery: {
                    arr: [
                        { name: '双色球', kj: '20:00停售/21:15开奖' },
                        { name: '大乐透', kj: '20:00停售/20:30开奖' },
                        { name: '福彩3D', kj: '20:00停售/21:15开奖' },
                        { name: '排列三', kj: '20:00停售/20:30开奖' },
                    ],
                    active: 0
                }
            },
            bidu: {
                show: false,
                title: '',

            }
        }
    },
    mounted () {
      this.fetchData();
    },
    methods: {
      fetchData () {
        this.$http.get('/stage-api/assist/market/list', {
          params: {
            // 预测类型 0双色球 1大乐透 2 3D 3排三
            perType:'0',
            preNumber: '',
            // 0最新期1上一期2下一期
            type:'0',
          }
        }).then(res => {
          console.log('res1127', res);
        })
        },
        navtit (index) {
            if (index == 1) {
                this.$refs.chaoshi.chaoshiShow = true;
            }
            if (index == 2) {
                this.$refs.zhaogu.zhaoguShow = true;
            }
            if (index == 3) {
                this.$refs.hetong.hetongShow = true;
            }
            this.mk1.active = index
        }
    }
}
</script>

<style lang="scss" scoped>
.tzzbd {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    .tit {
        span {
            display: block;
            margin: auto;
            width: fit-content;
            border-bottom: 3px solid #000a7b;
            padding: 0 12px;
            font-size: 19px;
            padding-bottom: 8px;
            margin-bottom: 10px;
            color: #bd3125;
        }
    }
    p {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-top: 0;
        line-height: 25px;
        margin: 0;
        font-size: 13px;
        padding: 10px;
        color: #4e8db9;
    }
}
.mk1 {
    height: 500px;
    color: #ffffff;
    background-image: linear-gradient(#165abd, #469cd9, #85d6f1);
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    img {
        position: absolute;
        left: calc(50% - 12%);
        max-width: 25%;
        bottom: 10px;
    }
    .tit {
        margin-top: 5px;
        margin-left: 100px;
        display: flex;
        align-items: center;
        .bt {
            background-color: #2d78c9;
            padding: 20px;
        }
        .nav {
            span {
                cursor: pointer;
                &.active {
                    position: relative;
                    &::after {
                        content: '';
                        display: block;
                        position: absolute;
                        left: calc(50% - 25px);
                        bottom: -7px;
                        width: 50px;
                        height: 3px;
                        background-color: #ffffff;
                    }
                }
            }
        }
        span {
            margin: 10px 30px;
        }
    }
    .content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        .cont {
            width: 610px;
            display: flex;
            flex-direction: column;
            align-items: center;
            h1 {
                font-weight: unset;
                position: relative;
                &::before,
                &::after {
                    content: '';
                    display: inline-block;
                }
                &::before {
                    position: absolute;
                    top: -26px;
                    left: -35px;
                    border-top: 4px solid #fff;
                    border-left: 4px solid #fff;
                    width: 83px;
                    height: 33px;
                }
                &::after {
                    position: absolute;
                    bottom: -6px;
                    right: -40px;
                    border-bottom: 4px solid #fff;
                    border-right: 4px solid #fff;
                    width: 37px;
                    height: 48px;
                }
            }
            p {
                width: 250px;
                display: flex;
                justify-content: space-between;
            }
            .btns {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 35px;
                span {
                    background-color: rgba(0, 0, 0, 0.2);
                    padding: 10px 30px;
                    border-radius: 10px;
                    cursor: pointer;
                    user-select: none;
                }
            }
            .more {
                width: 50px;
                height: 50px;
                position: absolute;
                bottom: 0px;
                &::before,
                &::after {
                    content: '';
                    display: block;
                    width: 20px;
                    height: 20px;
                    border-bottom: 3px solid rgba(255, 255, 255, 0.7);
                    border-right: 3px solid rgba(255, 255, 255, 0.7);
                    transform: rotate(45deg);
                    position: absolute;
                    left: 25%;
                }
                &::before {
                    top: 28%;
                }
            }
        }
    }
}
.mk2 {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 60px auto;
}
.mk3 {
    .el-carousel__item h3 {
        color: #475669;
        font-size: 180px;
        line-height: 300px;
        margin: 0;
        text-align: center;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
    }
}
.mk4 {
    color: #ffffff;
    .ul {
        display: flex;
        ul {
            list-style: none;
            padding-right: 70px;
            li {
                &:nth-child(1) {
                    font-weight: bold;
                    font-size: 16px;
                    position: relative;
                    &::after {
                        content: '';
                        display: block;
                        width: 30px;
                        height: 2px;
                        background-color: #ffffff;
                        margin-top: 10px;
                    }
                    cursor: default;
                }
                cursor: pointer;
                margin: 10px 0;
                font-size: 12px;
            }
        }
    }
    .ewm {
        margin-left: 40px;
        display: flex;
        padding-bottom: 30px;
        > div {
            text-align: center;
            margin-right: 10px;
            .img {
                width: 100px;
                height: 100px;
                line-height: 100px;
                color: #000000;
                background-color: #ffffff;
                margin-bottom: 10px;
            }
        }
    }
}
.mk5 {
    margin: 30px auto;
    padding: 20px 0;
    // height: 800px;
    position: relative;
    > .tit {
        text-align: center;
        margin-bottom: 30px;
        h3 {
            display: inline-block;
            position: relative;
            margin: 0;
            &:after {
                content: '';
                display: block;
                height: 2px;
                width: 70px;
                position: absolute;
                left: calc(50% - 35px);
                background-color: #000000;
            }
        }
    }
    .content {
        background-color: #ffffff;
        padding: 30px;
        .lottery {
            color: #e6000e;
            display: flex;
            justify-content: space-between;
            > div {
                cursor: pointer;
                span {
                    color: #000000;
                    font-weight: bold;
                    font-size: 18px;
                    &.active {
                        padding-bottom: 3px;
                        border-bottom: 5px solid #63a8f4;
                    }
                }
            }
        }
        .info {
            margin: 40px 0 20px;
            display: flex;
            img {
                margin-right: 20px;
                background-color: pink;
                width: 100px;
                height: 100px;
            }
            > div {
                flex: 1;
                .one {
                    display: flex;
                    justify-content: space-between;
                    > div {
                        span {
                            margin-right: 20px;
                            b {
                                color: red;
                            }
                        }
                    }
                }
                .num {
                    margin-top: 10px;
                    span {
                        display: inline-block;
                        width: 50px;
                        height: 50px;
                        text-align: center;
                        line-height: 50px;
                        font-size: 25px;
                        margin-right: 10px;
                        border-radius: 50%;
                        color: #ffffff;
                        &.red {
                            background-color: red;
                        }
                        &.blue {
                            background-color: blue;
                        }
                    }
                }
            }
        }
        .kjjg {
            .tit {
                border-top: 1px solid rgba(0, 0, 0, 0.2);
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                padding: 10px 0;
            }
        }
        .szcs {
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: flex;
            .left {
                width: 200px;
                border-right: 1px solid rgba(0, 0, 0, 0.2);
                > div {
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                    &:first-child {
                        background-color: #65a8f6;
                        color: #ffffff;
                        padding: 20px 0;
                        font-weight: bold;
                        font-size: 20px;
                    }
                    &:last-child {
                        font-size: 30px;
                        letter-spacing: 5px;
                        width: 100%;
                        line-height: 200px;
                        padding: 30px 0;
                        writing-mode: vertical-lr;
                    }
                }
            }
            .right {
                flex: 1;
                .tit {
                    text-align: center;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                    padding: 20px 0;
                }
            }
        }
    }
}
::v-deep.el-dialog__body {
    padding-top: 0;
}
</style>